import {NgModule} from '@angular/core';
import {MaskedCardPipe} from './masked-card.pipe';
import {CapitalizePipe} from './capitalize-text.pipe';


@NgModule({
    imports: [
        MaskedCardPipe,
        CapitalizePipe,
    ],
    exports: [
        MaskedCardPipe,
        CapitalizePipe,
    ],
    providers: [
        MaskedCardPipe,
        CapitalizePipe,
    ]
})
export class PipesModule {}
